export function PostBody({ html }: { html: string }) {
  return (
    <div
      className="wp-post-body"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
